import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { SharedItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Download } from '../Download';
import { Expires } from '../Expires';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Publish } from '../Publish';
import { Shared } from '../RowFor/Shared';
import { Size } from '../Size';

const SharedAutodeleteItem = (props: SharedItemProps) => {
    const windowWidth = useWindowWidth();
    const {
        onCheckboxClick,
        isSelected,
        isFolder,
        thumbUrl,
        kind,
        isVirus,
        ext,
        isAutoDelete,
        name,
        mtime,
        publicExpires,
        size,
        id,
        onDownload,
        onPublish,
        isPublic,
    } = props;

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Shared {...props} checkboxClassname={newStyles.check} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic
                        isFolder={isFolder}
                        thumbUrl={thumbUrl}
                        kind={kind}
                        isVirus={!!isVirus}
                        ext={ext || ''}
                        isAutoDelete={isAutoDelete}
                    />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} id={id} isRenameAvailable={props.renameAvailable} />
                            <Date date={mtime} hide />
                            <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared />
                            <Size size={size} />
                            <Download
                                onClick={onDownload}
                                size={size}
                                ext={isFolder ? 'zip' : ext}
                                id={id}
                                storage={EStorageType.sharedLinks}
                            />
                            <Publish onClick={onPublish} isActive={isPublic} />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <ItemName name={name} ext={ext || ''} id={id} isRenameAvailable={props.renameAvailable} />
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} />
                                    </span>
                                    <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared />
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    {mtime && <Date date={mtime} hide />}
                                    <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared />
                                    <Size size={size} />
                                </>
                            )}
                            <div className={styles.actionsWrapper}>
                                <Download
                                    onClick={onDownload}
                                    size={size}
                                    ext={isFolder ? 'zip' : ext}
                                    id={id}
                                    storage={EStorageType.sharedLinks}
                                />
                                <Publish onClick={onPublish} isActive={isPublic} />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default SharedAutodeleteItem;
